import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { PatientEvent } from './patient.events';

@Injectable({ providedIn: 'root' })
export class PatientEventProvider extends DomainEventProvider<PatientEvent> {}
